import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { save, load, modify, handleActive, userDelPer, userPwChg } from 'api/User';
import {resultAlert} from "utils/C";


const intialValue = { type: 2, id: "", pw: "", pwCheck: "", name: "", dept: "", deptText: "", phone: "", tele: "", note: "", devices:[], useYn:'y' };
// 0: 정상, 1: 초기, 2: 이상    
const intialCheck = { id: 1, idCheck: 1, pw: 1, pwCheck: 1, name: 1, dept: 1, phone: 1, tele: 0 };

export const userSlice = createSlice({
    name: "user",
    initialState: {
        value: intialValue,
        check: intialCheck,
        chg : false,
    },
    reducers: {
        // 사용자 정보 json 입력
        userInfo: (state, action) => {
            state.value = action.payload;
        },
        // 장비 관리
        setDevices: (state, action) => {
            state.value.devices = action.payload;
        },
        // 사용자 정보 입력 유효성 체크
        userCheck: (state, action) => {
            state.check = action.payload;
        },
        // 수정 모드 유효성 체크 기본값
        userModcheck: (state) => {
            state.check = { name: 0, dept: 0, phone: 0, tele: 0 };
        },
        // 사용자 추가
        userSave: (state) => {
            save(state.value).then( res =>  {
                resultAlert(res);
            } );
        },
        // 계정 영구삭제
        delePer: (state) => {
            userDelPer(state.value.id).then( res =>  {
                resultAlert(res);
            } );
        },
        // 비밀번호 초기화
        pwInit: (state) => {
            let tempPw = state.value.phone.substr(9,4);
            userPwChg({id:state.value.id, pw:tempPw}).then( res =>  {
                resultAlert(res);
            } );
        },

        // 사용자 정보 초기화
        userReset: (state) => {
            state.value = intialValue;
            state.check = intialCheck;
        }
    },
    extraReducers : (builder) => {
        builder
            .addCase(asyncLoad.fulfilled,(state, {payload}) => {
                state.value = payload;
            })
            .addCase(userActive.fulfilled,(state, {payload}) => {
                if (payload) state.chg = !state.chg;
                resultAlert(payload);
            })
            .addCase(userModify.fulfilled,(state, {payload}) => {
                if (payload) state.chg = !state.chg;
                resultAlert(payload);
            })
            .addCase(userSave.fulfilled,(state, {payload}) => {
                if (payload) state.chg = !state.chg;
                resultAlert(payload);
            })
            .addCase(delePer.fulfilled,(state, {payload}) => {
                if (payload) state.chg = !state.chg;
                resultAlert(payload);
            })

    }
});

// 사용자 상세 페이지 로드
export const asyncLoad = createAsyncThunk('user', async (userId) => {
    return load(userId); 
});

export const userActive = createAsyncThunk('userActive', async (userId) => {
    return handleActive(userId); 
});

export const userModify = createAsyncThunk('userModify', async (user) => {
    return modify(user); 
});

export const userSave = createAsyncThunk('userSave', async (user) => {
    return save(user); 
});

export const delePer = createAsyncThunk('userDel', async (userId) => {
    return userDelPer(userId); 
});


export default userSlice.reducer;
export const { userInfo, pwInit, setDevices, userCheck, userReset, userModcheck } = userSlice.actions;